// Shared types for the contractor documents admin review surface (#305).

export type ContractorDocumentType =
  | 'W9'
  | 'I9'
  | 'W4'
  | 'GOV_ID_FRONT'
  | 'GOV_ID_BACK'
  | 'SELFIE'
  | 'INSURANCE'
  | 'WORKERS_COMPENSATION'
  | 'GENERAL_LIABILITY'
  | 'LICENSE'
  | 'OTHER';

export type ContractorDocumentStatus =
  | 'PENDING'
  | 'PENDING_REVIEW'
  | 'APPROVED'
  | 'REJECTED'
  | 'REPLACED';

export type ContractorDocumentSource =
  | 'ATTACHED_FILE'
  | 'FILLED_IN_APP'
  | 'UPLOAD'
  | 'IN_APP_FORM';

export interface ContractorDocument {
  companyAcceptance?: 'approved' | 'rejected' | 'pending' | 'removed';
  evidenceStatus?: string;
  reviewRevision?: number;
  id: number;
  contractorId: number;
  companyId?: number | null;
  replacesDocumentId?: number | null;
  type: ContractorDocumentType;
  filename: string;
  originalFilename: string;
  documentSubtype?: string | null;
  mimeType: string;
  documentSource?: ContractorDocumentSource;
  source?: 'ATTACHED_FILE' | 'FILLED_IN_APP';
  templateKey?: string | null;
  completedFields?: Record<string, unknown> | null;
  signatureFilename?: string | null;
  completedAt?: string | null;
  submittedAt?: string | null;
  expiresAt?: string | null;
  status: ContractorDocumentStatus;
  rejectionReason: string | null;
  reviewedBy: number | null;
  uploadedAt: string;
  reviewedAt: string | null;
  supersededAt: string | null;
  contractor?: {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
    city?: string | null;
    state?: string | null;
  };
}

export const DOCUMENT_TYPE_LABELS: Record<ContractorDocumentType, string> = {
  W9: 'W-9 (Tax)',
  I9: 'I-9 (Employment Eligibility)',
  W4: 'W-4 (Employee Withholding)',
  GOV_ID_FRONT: 'Government ID — front',
  GOV_ID_BACK: 'Government ID — back',
  SELFIE: 'Identity selfie',
  INSURANCE: 'Other Insurance',
  WORKERS_COMPENSATION: 'Workers compensation',
  GENERAL_LIABILITY: 'General liability',
  LICENSE: 'License',
  OTHER: 'Other'
};

export const DOCUMENT_SOURCE_LABELS: Record<ContractorDocumentSource, string> =
  {
    UPLOAD: 'Uploaded file',
    IN_APP_FORM: 'Completed in app',
    ATTACHED_FILE: 'Attached file',
    FILLED_IN_APP: 'Completed in app'
  };

export const DOCUMENT_TYPE_ORDER: ContractorDocumentType[] = [
  'W9',
  'I9',
  'W4',
  'GOV_ID_FRONT',
  'GOV_ID_BACK',
  'SELFIE',
  'INSURANCE',
  'WORKERS_COMPENSATION',
  'GENERAL_LIABILITY',
  'LICENSE',
  'OTHER'
];

export const STATUS_BADGE_COLORS: Record<
  ContractorDocumentStatus,
  'default' | 'warning' | 'success' | 'error'
> = {
  PENDING: 'warning',
  PENDING_REVIEW: 'warning',
  APPROVED: 'success',
  REJECTED: 'error',
  REPLACED: 'default'
};

export const DOCUMENT_STATUS_LABELS: Record<ContractorDocumentStatus, string> = {
  PENDING: 'Needs review',
  PENDING_REVIEW: 'Needs review',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  REPLACED: 'Replaced'
};

export const COMPANY_ACCEPTANCE_LABELS: Record<string, string> = {
  approved: 'Approved by company',
  rejected: 'Rejected by company',
  pending: 'Awaiting company review',
  removed: 'Company approval removed'
};
